import { useCallback } from 'react';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdminApi = () => {
  const { token } = useAdminAuth();

  const request = useCallback(async (endpoint, options = {}) => {
    const url = `${API_URL}/api${endpoint}`;
    
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    };

    try {
      const response = await axios({
        url,
        method: options.method || 'GET',
        headers,
        data: options.body ? JSON.parse(options.body) : undefined,
      });

      return { success: true, data: response.data };
    } catch (error) {
      if (error.response) {
        return { success: false, error: error.response.data?.detail || 'Erreur serveur', status: error.response.status };
      }
      return { success: false, error: 'Erreur de connexion', status: 0 };
    }
  }, [token]);

  const get = useCallback((endpoint) => request(endpoint, { method: 'GET' }), [request]);
  
  const post = useCallback((endpoint, body) => request(endpoint, { 
    method: 'POST', 
    body: JSON.stringify(body) 
  }), [request]);
  
  const put = useCallback((endpoint, body) => request(endpoint, { 
    method: 'PUT', 
    body: JSON.stringify(body) 
  }), [request]);
  
  const del = useCallback((endpoint) => request(endpoint, { method: 'DELETE' }), [request]);

  const patch = useCallback((endpoint, body) => request(endpoint, { 
    method: 'PATCH', 
    body: JSON.stringify(body) 
  }), [request]);

  return { get, post, put, del, patch, request, token };
};

export default useAdminApi;
